<template>
  <div id="app">
    <!-- <Nav class="mb-6" v-if='$auth.isAuthenticated' /> -->
    <nav-bar
      class="sticky top-0"
      style="z-index:2000"
      v-if="
        isAuthenticated & ($route.name != 'WatchNarrative') &&
          $route.name != 'Dashboard'
      "
    ></nav-bar>
    <error-modal v-if="errorsPresent" :message="errorMessage"></error-modal>
    <message-modal v-if="messageIsVisible" :messageData="messageData" />
    <!-- <button class="margin-4 p-3 bg-gray-300" @click="check">PRESS ME</button> -->
    <router-view v-on:error="showErrors" />
  </div>
</template>

<script>
import NavBar from "./components/NavBar.vue";
import ErrorModal from "./components/ErrorModal.vue";
import MessageModal from './components/MessageModal.vue'
import { checkUser, getToken, EventBus } from "@/utils.js";
export default {
  name: "App",
  components: {
    NavBar,
    ErrorModal,
    MessageModal
  },

  methods: {
    showErrors(message) {
      this.errorMessage = JSON.parse(message).message;
      this.errorsPresent = true;
      setTimeout(() => {
        this.errorsPresent = false;
      }, 3000);
    },
  },

  data() {
    return {
      errorMessage: "",
      errorsPresent: false,
    };
  },

  computed: {
    isAuthenticated() {
      return this.$store.state.users.isAuthenticated;
    },
    messageIsVisible() {
      return this.$store.state.modals.visible;
    },
    messageData() {
      return this.$store.state.modals;
    },
    user() {
      return this.$store.state.users.user
    }
  },
  watch: {
     user(newVal) {
      if(newVal && this.$route.name === 'Home') {
         this.$router.push({
          name: "Dashboard",
          params: { username: newVal.username },
        });
      } else if(newVal === null) {
        this.$router.push({
          name: "Home",
        });
      }
    }
  },
  mounted() {
    EventBus.$on("error", this.showErrors); // listen to the global event bus
  },
};
</script>

<style>
body {
  /* background-color: #9ca3af; */
  /* background-color: #374151; */
}
</style>
